import { Component, Injector, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';
import { EnforcementService } from 'src/app/Services/enforcement.service';
import { Validators } from '@angular/forms';

interface EnumDto {
  Id: number;
  Name: string;
}

interface PrinterConfigurations {
  PaperSizes: EnumDto[];
  PrinterTypes: EnumDto[];
}

@Component({
    selector: 'app-editprinter',
    templateUrl: './editprinter.component.html',
    styleUrls: ['./editprinter.component.scss'],
    standalone: false
})
export class EditPrinterComponent extends ModelEditor implements OnInit, AfterViewInit {
  public printerTypes: EnumDto[] = [];
  public paperSizes: EnumDto[] = [];

  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    public enforcementService: EnforcementService,
    private injector: Injector,
    private toastr: ToastrService
  ) {
    super("enforcement/printers", injector);
  }

  public DefaultModel() {
    return {
      Id: '',
      Name: '',
      MacAddress: '',
      PrinterType: null,
      PrinterPaperSize: null,
      DisableFormatting: false
    };
  }

  public override AfterModelLoaded() {
    // Load printer configurations if they haven't been loaded yet
    if (!this.printerTypes.length) {
      this.apiService.Get<PrinterConfigurations>('enforcement/printers/configurations').then((res => {
        this.printerTypes = res.PrinterTypes;
        this.paperSizes = res.PaperSizes;
      }), error => {
        console.error(`Error loading printer configurations: ${error}`);
        this.toastr.error('Failed to load printer configurations. Please try refreshing the page.');
        this.printerTypes = [];
        this.paperSizes = [];
      });
    }
  }

  public ngAfterViewInit(): void {
  }

  public BeforeSave(): boolean {
    return true;
  }

  public Validators() {
      return {
        "Name": [Validators.required],
        "PrinterType": [Validators.required],
        "PrinterPaperSize": [Validators.required],
      };
  }
} 
